import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SessionRecovery = () => {
  const location = useLocation();

  useEffect(() => {
    let wakeLockTimer = null;
    let lastActiveTime = Date.now();

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const now = Date.now();
        const elapsed = now - lastActiveTime;

        // If the tab was hidden for more than 5 minutes, do a soft recovery
        if (elapsed > 5 * 60 * 1000) {
          const isAuthenticated = localStorage.getItem('isAuthenticated');
          const token = localStorage.getItem('token');

          if (isAuthenticated && token) {
            // Check if the page content is still rendered
            const appRoot = document.getElementById('root');
            const hasContent = appRoot && appRoot.innerHTML.trim().length > 100;

            if (!hasContent) {
              // App state lost — reload
              window.location.reload();
              return;
            }
          } else {
            // Session expired while sleeping — redirect to login
            window.location.href = '/login';
            return;
          }
        }

        lastActiveTime = now;
      } else {
        lastActiveTime = Date.now();
      }
    };

    // Handle page show event (fires on back/forward navigation and bfcache restore)
    const handlePageShow = (event) => {
      if (event.persisted) {
        // Page was restored from bfcache — check if app state is intact
        const appRoot = document.getElementById('root');
        const hasContent = appRoot && appRoot.innerHTML.trim().length > 100;

        if (!hasContent) {
          window.location.reload();
        }
      }
    };

    // Handle online/offline transitions (common after sleep)
    const handleOnline = () => {
      const appRoot = document.getElementById('root');
      const hasContent = appRoot && appRoot.innerHTML.trim().length > 100;

      if (!hasContent) {
        window.location.reload();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pageshow', handlePageShow);
    window.addEventListener('online', handleOnline);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('online', handleOnline);
      if (wakeLockTimer) clearTimeout(wakeLockTimer);
    };
  }, []);

  // Store the current path so back button can recover
  useEffect(() => {
    const currentPath = location.pathname + location.search;
    sessionStorage.setItem('nimble_last_path', currentPath);
  }, [location]);

  return null;
};

export default SessionRecovery;
